export type Point = {
  x: number;
  y: number;
};

export const rotatePoint = (point: Point, deg: number, origin: Point = { x: 0.5, y: 0.5 }) => {
  const rad = (deg / 360) * 2 * Math.PI;

  const { x: x1, y: y1 } = origin;
  const tx = point.x - x1;
  const ty = point.y - y1;

  const rx = tx * Math.cos(rad) - ty * Math.sin(rad);
  const ry = tx * Math.sin(rad) + ty * Math.cos(rad);

  return { x: rx + x1, y: ry + y1 };
};

export type Box = { x: number; y: number; w: number; h: number };
